import {AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2} from '@angular/core';

@Directive({
  selector: '[ptWidgetSelector]'
})
export class WidgetSelectorDirective implements AfterViewInit {
  @Input('ptWidgetSelector') internalId: string;
  private element;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    this.element = document.getElementById('widget_' + this.internalId);
  }

  @HostListener('mouseenter') mouseover() {
    if (this.element) {
      this.renderer.addClass(this.element, 'widget-border--selected');
    }
    // this.renderer.setStyle(this.elementRef.nativeElement, 'background-color', 'blue');
  }

  @HostListener('mouseleave') mouseleave() {
    if (this.element) {
      this.renderer.removeClass(this.element, 'widget-border--selected');
    }
    // this.renderer.setStyle(this.elementRef.nativeElement, 'background-color', 'transparent');
  }
}
